import { render, staticRenderFns } from "./DeleteTemplate.vue?vue&type=template&id=d60e4bfa&"
import script from "./DeleteTemplate.vue?vue&type=script&lang=js&"
export * from "./DeleteTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports